import React, { useEffect, useState } from "react";
import Footer from "../component/Footer";
import { Helmet } from "react-helmet";
import axios from "axios";
import { Link, NavLink, redirect } from "react-router-dom";
import { toast } from "react-toastify";
import Header1 from "../component/Header1";
function Home() {
  useEffect(() => {
    fetch();
    document.getElementById('spinner').style.display = "none";
  });

  const [data, setData] = useState([]);
  const fetch = async () => {
    const res = await axios.get(`https://www.rajvicosmeticclinic.com/RajviApi/categories_get`);
    setData(res.data);
  };


  const [cate_id, setcate_id] = useState('');
  const [service_id, setservice_id] = useState('');
  const [app_Date, setapp_Date] = useState('');

  const [data1, setData1] = useState([]);
  const changecategories = async (e) => {
    setcate_id(e.target.value);
    const res = await axios.get(
      `https://www.rajvicosmeticclinic.com/RajviApi/services_single_get?id=${e.target.value}`
    );
    setData1(res.data);
  };

  function validation() {
    var ans = true;
    if (cate_id == "") {
      toast.error("Categories Field is required");
      ans = false;
      return false;
    }
    if (service_id == "") {
      toast.error(" Services Field is required");
      ans = false;
      return false;
    }
    if (app_Date == "") {
      toast.error("Appointment Date is required");
      ans = false;
      return false;
    }
    return ans;
  }

  const submithandle = async (i) => {
    i.preventDefault();
    if (validation()) {
      localStorage.getItem('userid')
      const formData = new FormData();
      formData.append('id', new Date().getTime().toString());
      formData.append('service_id', service_id);
      formData.append('userid', localStorage.getItem('userid'));
      formData.append('app_Date', app_Date);

      if (localStorage.getItem("userid")) {
        const res = await axios.post(`https://www.rajvicosmeticclinic.com/RajviApi/appointment_post`, formData);
        console.log(res);
        if (res.status == 200) {
          toast.success(res.data.message);
          redirect('/');
        }
      }
      else {
        toast.warning("Please Login First Now");
        return false;
      }
    }

  };


  return (
    <>

      <div>

        <Header1/>
        {/* About Start */}
        <div className="container-fluid py-5">
          <div className="container">
            <div className="row justify-content-center text-center">
              <div className="col-lg-6">
                <h6 className="d-inline-block bg-light text-primary text-uppercase py-1 px-2">
                  About
                </h6>
                <h1 className="mb-5">Rajvi Cosmetic Clinic</h1>
                <div class="spinner-border text-danger mt-5" id='spinner'></div>
              </div>
            </div>
            <div className="row align-items-center">
              <div className="col-lg-6 pb-5 pb-lg-0">
                <img className="img-fluid w-100" src="/img/about.jpg" alt />
              </div>
              <div className="col-lg-6">
                <h6 className="d-inline-block text-primary text-uppercase bg-light py-1 px-2">
                  About Us
                </h6>
                <h1 className="mb-4">
                  Your Best Hair &amp; Skin Care Center
                </h1>
                <p className="pl-4 border-left border-primary">
                  A state of the art multispeciality skin & cosmetic clinic promising world-class treatments done by highly specialized professionals in environs that assure optimum care and comfort for each of their clients is what defines Rajvi Cosmetic Clinic.
                </p>
                <div className="row pt-3">
                  <div className="col-6">
                    <div className="bg-light text-center p-4">
                      <h3
                        className="display-4 text-primary"
                        data-toggle="counter-up"
                      >
                        18
                      </h3>
                      <h6 className="text-uppercase">Hair & Skin Experts</h6>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="bg-light text-center p-4">
                      <h3
                        className="display-4 text-primary"
                        data-toggle="counter-up"
                      >
                        1000
                      </h3>
                      <h6 className="text-uppercase">Happy Clients</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* About End */}

        {/* Team Start */}
        <div className="container-fluid py-5">
          <div className="container pt-5">
            <div className="row justify-content-center text-center">
              <div className="col-lg-6">
                <h6 className="d-inline-block bg-light text-primary text-uppercase py-1 px-2">
                  Our Services
                </h6>
                <h1 className="mb-5">Hair & Skin Services</h1>
              </div>
            </div>
            <div className="row">
              {
                (data.length > 0) ?
                  data.map((value, index) => {
                    return (
                      <div className="col-lg col-md">
                        <div className="team position-relative overflow-hidden mb-5">
                          <img width="100%" height="100%" src={`https://www.rajvicosmeticclinic.com/RajviApi/upload/categories/${value.cate_img}`} alt />
                          <div className="position-relative text-center">
                            <div className="team-text bg-primary text-white">
                              <h3 className="text-white text-uppercase">{value.cate_name}</h3>
                              <p className="m-0">THE BEST {value.cate_name} EXPERT</p>
                            </div>
                            <div className="team-social bg-dark text-center">
                              <NavLink to={"/services_details/" + value.id} className="btn btn-primary" >
                                More Service
                              </NavLink>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }) : null
              }
            </div>
          </div>
        </div>
        {/* Team End */}


        {/* Service Start */}
        <div className="container-fluid px-0 py-5 my-5">

          <div className="row justify-content-center bg-appointment mx-0">
            <div className="col-lg-6 py-5">
              <div
                className="p-5 my-5"
                style={{ background: "rgba(33, 30, 28, 0.7)" }}
              >
                <h1 className="text-white text-center mb-4">
                  Make Appointment
                </h1>
                <form
                  action=""
                  role="form"
                  method="post"
                  onSubmit={submithandle}
                >
                  <div className="form-row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="">Select Categories</label>
                        <select
                          onChange={(e) => changecategories(e)}
                          name="cate_id"
                          className="form-control bg-transparent p-4"
                        >
                          <option value="">Select Categories</option>
                          {(data.length > 0) ? data.map((value) => {
                            return (
                              <option value={value.id}>
                                {value.cate_name}
                              </option>
                            );
                          }) : null
                          }
                        </select>
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="">Select services</label>
                        <select
                          onChange={(e) => setservice_id(e.target.value)}
                          name="service_id"
                          className="form-control bg-transparent p-4"
                        >
                          <option value="" >Select services</option>
                          {
                            (data1.length > 0) ? data1.map((value) => {
                              return (
                                <option value={value.id}>
                                  {value.service_name}
                                </option>
                              );
                            }) : null}
                        </select>
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="">Select Date</label>

                        <input
                          type="date"
                          onChange={(e) => setapp_Date(e.target.value)}
                          name="app_Date"
                          className="form-control bg-transparent p-4 datetimepicker-input"
                          placeholder="Select Date"
                          min=""
                        />
                        <div
                          className="date"
                          id="date"
                          name="app_Date"
                          data-target-input="nearest"
                        >
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <button
                        className="btn btn-primary btn-block"
                        type="submit"
                        style={{ height: 47 }}
                      >
                        Make Appointment
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Testimonial Start */}
        <div className="container-fluid py-5">
          <div className="container">
            <div className="row justify-content-center text-center">
              <div className="col-lg-6">
                <h6 className="d-inline-block bg-light text-primary text-uppercase py-1 px-2">
                  Testimonial
                </h6>
                <h1 className="mb-5">Our Client Testimonial</h1>
              </div>
            </div>
            <div className="row align-items-center">
              <div className="col-lg-6 pb-5 pb-lg-0">
                <img
                  className="img-fluid w-100"
                  src="/img/testimonial.jpg"
                  alt
                />
              </div>
              <div className="col-lg-6">
                <h6 className="d-inline-block text-primary text-uppercase bg-light py-1 px-2">
                  Testimonial
                </h6>
                <h1 className="mb-4">What Our Clients Say!</h1>
                <div className="owl-carousel testimonial-carousel">
                  <div className="position-relative">
                    <i
                      className="fa fa-3x fa-quote-right text-primary position-absolute"
                      style={{ top: "-6px", right: 0 }}
                    />
                    <div className="d-flex align-items-center mb-3">
                      <img
                        className="img-fluid rounded-circle"
                        src="/img/testimonial-1.jpg"
                        style={{ width: 60, height: 60 }}
                        alt
                      />
                      <div className="ml-3">
                        <h6 className="text-uppercase">Payal patel</h6>
                        <span>Ahmedabad</span>
                      </div>
                    </div>
                    <p className="m-0">
                      I had been hesitant to try anti-aging treatments, but this has been a game-changer. The results are incredible — my skin looks fresh, radiant, and noticeably younger. I'm so happy I took the plunge!
                    </p>
                  </div>
                  <div className="position-relative">
                    <i
                      className="fa fa-3x fa-quote-right text-primary position-absolute"
                      style={{ top: "-6px", right: 0 }}
                    />
                    <div className="d-flex align-items-center mb-3">
                      <img
                        className="img-fluid rounded-circle"
                        src="/img/testimonial-2.jpg"
                        style={{ width: 60, height: 60 }}
                        alt
                      />
                      <div className="ml-3">
                        <h6 className="text-uppercase">Rekha, 40 Age </h6>
                        <span>Ahmedabad</span>
                      </div>
                    </div>
                    <p className="m-0">
                      I've been struggling with acne and uneven skin tone for years, but after just one HydraFacial, I noticed a huge difference. My skin feels fresh, smooth, and hydrated like never before!
                    </p>
                  </div>
                  <div className="position-relative">
                    <i
                      className="fa fa-3x fa-quote-right text-primary position-absolute"
                      style={{ top: "-6px", right: 0 }}
                    />
                    <div className="d-flex align-items-center mb-3">
                      <img
                        className="img-fluid rounded-circle"
                        src="/img/testimonial-3.jpg"
                        style={{ width: 60, height: 60 }}
                        alt
                      />
                      <div className="ml-3">
                        <h6 className="text-uppercase">Shilpa, 42 Age</h6>
                        <span>Ahmedabad</span>
                      </div>
                    </div>
                    <p className="m-0">
                      The best decision I've made! Laser hair removal has saved me so much time and effort. My skin is smoother, and the hair growth has reduced dramatically. It's been an amazing experience overall!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Testimonial End */}
        <Footer />
      </div>

      <Helmet>

        <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.bundle.min.js"></script>
        <script src="lib/easing/easing.min.js"></script>
        <script src="lib/waypoints/waypoints.min.js"></script>
        <script src="lib/counterup/counterup.min.js"></script>
        <script src="lib/owlcarousel/owl.carousel.min.js"></script>
        <script src="lib/tempusdominus/js/moment.min.js"></script>
        <script src="lib/tempusdominus/js/moment-timezone.min.js"></script>
        <script src="lib/tempusdominus/js/tempusdominus-bootstrap-4.min.js"></script>

        <script src="mail/jqBootstrapValidation.min.js"></script>
        <script src="mail/contact.js"></script>

        <script src="js/main.js"></script>
      </Helmet>
    </>
  );
}
export default Home;
